<template>
	<div>
		<v-progress-circular indeterminate color="primary" v-if="isPhoneVerified === 1" />
		<p class="text--secondary" v-text="confirmationMessage"></p>
	</div>
</template>

<script>
export default {
	name: 'PhoneConfirmStatus',
	props: {
		isPhoneVerified: {
			type: Number,
			required: true,
		},
	},
	computed: {
		confirmationMessage() {
			let message = '';
			switch (this.isPhoneVerified) {
				case 0:
					message = 'Número no validado';
					break;
				case 1:
					message = 'Validación en proceso';
					break;
				case 2:
					message = 'Número válidado';
					break;
			}
			return message;
		},
	},
};
</script>
